import type { RegisterOAuth } from "../types";



export const REGISTER_OAUTH_STORAGE_KEY = "aicarma_register_oauth";

export function readRegisterOAuthStorage(): RegisterOAuth | null {
  try {
    const raw = sessionStorage.getItem(REGISTER_OAUTH_STORAGE_KEY);

    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearRegisterOAuthStorage() {
  try {
    sessionStorage.removeItem(REGISTER_OAUTH_STORAGE_KEY);
  } catch { /* noop */ }
}

export function saveRegisterOAuthStorage(oauth: RegisterOAuth): void {
  try {
    sessionStorage.setItem(REGISTER_OAUTH_STORAGE_KEY, JSON.stringify(oauth));
  } catch { /* noop */ }
}